import React from 'react'
import { compose } from 'recompose'

import EditorOverlay from '../utils/EditorOverlay'

export default ({ LinkPlugin }) => ({
  decorator = x => x,
  isEditable,
  fetchNotes,
  appDomain,
  organizationDomain,
  showNoteByToken,
} = {}) => {
  const onClickDecorator = Component => props => {
    return isEditable ? (
      <EditorOverlay popoverContent={<LinkPlugin.LinkPreview {...props} />}>
        <Component {...props} />
      </EditorOverlay>
    ) : (
      <Component {...props} />
    )
  }

  return LinkPlugin({
    fetchNotes,
    appDomain,
    organizationDomain,
    showNoteByToken,
    decorator: compose(
      decorator,
      onClickDecorator
    ),
  })
}
